<template>
  <div :class="classes">
    <t-caspanel
      ref="caspanel"
      :prefix-class="prefixCardClass"
      :data="dataSource"
      :disabled="disabled"
      :change-on-select="changeOnSelect"
      :size="size"
      :filterable="filterable"
      :clearable="clearable"
    ></t-caspanel>
  </div>
</template>
<script>
import { PREFIX_CLASS } from '../../utils/constants'
import TCaspanel from './caspanel.vue'
import Emitter from '../../mixins/emitter'
import locale from '../../mixins/locale'
import { t } from '../../locale'

const PREFIX_CASCADER_CLASS = `${PREFIX_CLASS}cascader`

export default {
  name: 'TCascader',
  components: { TCaspanel },
  mixins: [locale, Emitter],
  props: {
    dataSource: {
      type: Array,
      default() {
        return []
      }
    },
    value: {
      type: Array,
      default() {
        return []
      }
    },
    disabled: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default () {
        return t('t.cascader.placeholder')
      }
    },
    size: {
      type: String,
      validator(value) {
        return ['sm', '', 'lg'].includes(value)
      },
      default: ''
    },
    changeOnSelect: {
      type: Boolean,
      default: false
    },
    renderFormat: {
      type: Function,
      default(label) {
        return label.join(' / ')
      }
    },
    loader: {
      type: Function,
      default: () => {}
    },
    filterable: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      clearable: false,
      selected: [],
      tmpSelected: [],
      currentValue: this.value
    }
  },
  computed: {
    prefixCardClass() {
      return PREFIX_CASCADER_CLASS
    },
    classes() {
      return [
        `${PREFIX_CASCADER_CLASS}`,
        {
          [`${PREFIX_CASCADER_CLASS}-disabled`]: this.disabled
        }
      ]
    },
    displayRender() {
      let label = []
      for (let i = 0; i < this.selected.length; i++) {
        label.push(this.selected[i].label)
      }

      return this.renderFormat(label, this.selected)
    }
  },
  watch: {
    value(val) {
      this.currentValue = val
      if (!val.length) this.selected = []
    },
    currentValue() {
      this.$emit('input', this.currentValue)
    },
    data: {
      deep: true,
      handler() {
        this.$nextTick(() => this.$_updateSelected())
      }
    }
  },
  mounted() {
    this.$_updateSelected(true)
  },
  created() {
    this.$on('on-result-change', params => {
      // lastValue: is click the final val
      // fromInit: is this emit from update value
      const lastValue = params.lastValue
      const changeOnSelect = params.changeOnSelect
      const fromInit = params.fromInit

      if (lastValue || changeOnSelect) {
        const oldVal = JSON.stringify(this.currentValue)
        this.selected = this.tmpSelected

        let newVal = []
        this.selected.forEach(item => {
          newVal.push(item.value)
        })

        if (!fromInit) {
          this.currentValue = newVal
          this.$_emitValue(this.currentValue, oldVal)
        }
      }
    })
  },
  methods: {
    updateResult(result) {
      this.tmpSelected = result
    },
    $_updateSelected(init = false) {
      if (!this.changeOnSelect || init) {
        this.broadcast('TCaspanel', 'on-find-selected', {
          value: this.currentValue
        })
      }
    },
    $_emitValue(val, oldVal) {
      let that = this
      if (JSON.stringify(val) !== oldVal) {
        this.$emit(
          'on-change',
          that.currentValue,
          JSON.parse(JSON.stringify(that.selected))
        )
        this.$nextTick(() => {
          this.dispatch('FormItem', 'on-form-change', {
            value: this.currentValue,
            selected: JSON.parse(JSON.stringify(this.selected))
          })
        })
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/module/cascader/cascader.vue